import { render, staticRenderFns } from "./StoresCarts.vue?vue&type=template&id=32aa4f08&scoped=true&"
import script from "./StoresCarts.vue?vue&type=script&lang=js&"
export * from "./StoresCarts.vue?vue&type=script&lang=js&"
import style0 from "./StoresCarts.vue?vue&type=style&index=0&id=32aa4f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aa4f08",
  null
  
)

export default component.exports